import { useQuery } from "react-query";
import { getData } from "../newApis/dotNetApiMethods";
import * as ajaxEndpoints from "../api/ajax-endpoints";

export type IParams = {
  startDate?: string | undefined;
  endDate?: string | undefined;
  transactionStatus?: string | undefined;
  sessionId?: string | undefined;
  transactionReference?: string | undefined;
  transferProvider?: string | undefined;
  institutionCode?: string | undefined;
  page: number;
  pageSize: number;
};

const fetchNIPTransactions = async ({
  startDate,
  endDate,
  transactionStatus,
  transactionReference,
  institutionCode,
  transferProvider,
  pageSize,
  page,
  sessionId,
}: IParams) => {
  let queryParams = `?page=${page}&pageSize=${pageSize}`;

  if (startDate) queryParams = `${queryParams}&startDate=${startDate}`;
  if (endDate) queryParams = `${queryParams}&endDate=${endDate}`;
  if (transactionStatus)
    queryParams = `${queryParams}&transactionStatus=${transactionStatus}`;
  if (transactionReference)
    queryParams = `${queryParams}&transactionReference=${transactionReference}`;
  if (institutionCode)
    queryParams = `${queryParams}&institutionCode=${institutionCode}`;
  if (transferProvider)
    queryParams = `${queryParams}&transferProvider=${transferProvider}`;
  if (sessionId) queryParams = `${queryParams}&sessionId=${sessionId}`;

  const response = await getData(
    `${ajaxEndpoints.FETCH_NIP_TRANSACTIONS}${queryParams}`,
  );

  return response.data;
};

export const useFetchNIPTransactions = (params: IParams) => {
  return useQuery(["fetchNIPTransactions", params], () =>
    fetchNIPTransactions(params),
  );
};
